import { render } from "./Friday.vue?vue&type=template&id=272c87d8&scoped=true"
import script from "./Friday.vue?vue&type=script&lang=js"
export * from "./Friday.vue?vue&type=script&lang=js"

import "./Friday.vue?vue&type=style&index=0&id=272c87d8&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272c87d8"]])

export default __exports__